// extracted by mini-css-extract-plugin
module.exports = {"Active":"Paginator_Active__3ytWu"};